import React, {
  useState,
  useEffect,
  createContext,
  Fragment,
  useRef,
  useMemo,
  useImperativeHandle,
  forwardRef,
} from "react";
import "../../../assets/styles/map.css";
import useScripts from "../../../utils/UseScripts";
import { IoEyeOutline } from "react-icons/io5";
import PageLoader from "../../../components/common/Loader/PageLoader";
import { useTheme } from "../../../components/ThemeSwitcher/ThemeSwitcher";
import { useTranslation } from "react-i18next";
import { useTable, useSortBy, usePagination } from "react-table";
import SortableHeader from "../../../utils/SortableHeader";
import { FiEdit2 } from "react-icons/fi";
import Pagination from "../../../utils/Pagination";
import DivLoader from "../../../components/common/Loader/DivLoader";
import "./DataRequest.css";
import NoResults from "../../../components/common/NoResults";
import { useNavigate } from "react-router-dom";
import { ButtonGroup, ToggleButton } from "react-bootstrap";
import i18n from "../../../i18n";
import { showAlert, addGraphicsToLayer, showUpdationModal } from "../../../utils/Helpers";
import { getLocalStorageItem, validateEmail } from "../../../utils/HelperFunctions";
import Sketch from "@arcgis/core/widgets/Sketch";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import Graphic from "@arcgis/core/Graphic";
import PopupTemplate from "@arcgis/core/PopupTemplate";
import { calculateGraphicsExtent, getSymbol } from "./DataRequestUtils";
import JSZip from "jszip";
import * as shapefile from "shapefile";
import * as toGeoJSON from "togeojson";
import { convertToShapefile, getFeaturesByFilter } from "../../enviroportal/components/DataExport/DataExportUtils";
import { arcgisToGeoJSON } from "@terraformer/arcgis";
import shpwrite from '@mapbox/shp-write';
import { saveAs } from "file-saver";
import esriRequest from "@arcgis/core/request.js";
import Query from "@arcgis/core/rest/support/Query";
import * as query from "@arcgis/core/rest/query";
import "../../../assets/styles/dataExtraction.css";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import CustomDropdownIndicator from "../../../components/common/CustomDropdownIndicator";
import Select from "react-select";
import { FiUpload } from "react-icons/fi";
import DOMPurify from "dompurify";
import { BiFilterAlt } from "react-icons/bi";
import { RxCross2 } from "react-icons/rx";
import { datasearchQuery } from "../../enviroportal/components/Search/SearchUtils";
import DataRequestFeatureDetails from "./DataRequestFeatureDetails";
import { applyTheme, updateAllCharts, updateImages } from "../../../utils/theme";
import esriConfig from "@arcgis/core/config.js";
import { GetToken } from "../../../utils/HelperFunctions";
import esriId from "@arcgis/core/identity/IdentityManager.js";
//import Pagination from "../../../utils/Pagination";
export const DataRequestContext = createContext();
let elementInstances = {};
let allSelectedResults = [];
const DataRequest = forwardRef((props, ref) => {
  const DEFAULT_PAGE_SIZE = 10;
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const { mapview, fetchOnly = false } = props;
  const [mapservices, setMapservices] = useState([]);
  const [maplayers, setMapLayers] = useState([]);
  const [selectedMapservice, setSelectedMapservice] = useState("");
  const [selectedLayers, setSelectedLayers] = useState([]);
  const [loading, showLoading] = React.useState(false);
  const { t } = useTranslation();
  let { theme } = useTheme();
  const navigate = useNavigate();
  const [AOItype, setAOItype] = useState("");
  const [AOI, setAOI] = useState(null);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [filter, setFilter] = useState({
    pageNumber: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    sortBy: "requesteddate", //"id",
    sortOrder: "desc", //"asc",
    startDate: "",
    endDate: "",
    status: "",
  });
  const [errors, setErrors] = useState({});
  const [email, setEmail] = useState(getLocalStorageItem("Email") || "");
  const [purpose, setPurpose] = useState("");
  const [selectedFileType, setSelectedFileType] = useState("shp");
  const externalFileRef = useRef(null);
  const [files, setFiles] = useState([]);
  let aoiLayer = useRef(new GraphicsLayer({ id: "AOILayer" }));
  const [aoiAddedToMap, setAOIaddedToMap] = useState(false);
  const [drawTool, setDrawTool] = useState(null);
  // let dataRequestLayer, dataRequestLayerUrl, drFields;
  const dataRequestLayerRef = useRef(null);
  const dataRequestLayerUrlRef = useRef(null);
  const drFieldsRef = useRef(null);
  const [filterVisible, setFilterVisible] = useState(false);
  const [showDataSection, setShowDataSection] = useState(false);
  const [dataRequests, setDataRequests] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [noResults, setNoResults] = useState(false);
  const [showReqDetails, setShowReqDetails] = useState(false);
  const [status, Setstatus] = useState(null);
  const [reqId, setReqId] = useState(null);
  const [portalToken, setPortalToken] = useState(null);
  const radios = [
    {
      name: "drawAOI",
      value: "1",
      icon: (
        <img alt=""
          className="me-2 dataReqTabIcon"
          src={`${process.env.PUBLIC_URL}/images/Drawing.svg`}
        />
      ),
    },
    {
      name: "uploadAOI",
      value: "2",
      icon: <FiUpload size={20} className="me-2" />,
    },
  ];
  const [drFilter, setDrFilter] = useState({
    startDate: "",
    endDate: "",
    status: "Approved",
    where: ""
  });
  const [tabularData, setTabularData] = useState(false);
  useEffect(() => {
    const fetchToken = async () => {
      const data = await GetToken();
      setPortalToken(data.token);
    };

    fetchToken();
  }, []);
  const updateTheme = (event) => {
    const newTheme = event.detail;
    theme = newTheme;
    //updateAllCharts(chartInstances, theme,t,"ModuleName");
    const el = document.getElementById("DataRequesticon1");
    if (el) elementInstances["p3"] = el;
    applyTheme(elementInstances, theme, "DataRequest")
  };

  useEffect(() => {
    window.addEventListener("themeChanged", updateTheme);

    return () => {
      window.removeEventListener("themeChanged", updateTheme);
    };
  }, [])
  /**arcgis column mapping */
  const columnMapping = {
    objectid: "objectid",
    enmapservicename: "enmapservicename",
    armapservicename: "armapservicename",
    requesteddate: "requesteddate",
    requestedby: "requestedby",
    updatedby: "updatedby",
    updateddate: "updateddate",
    status: "status",
  };


  useScripts([`${process.env.PUBLIC_URL}/config/EnviroportalConfig.js`], () => {
    setScriptLoaded(true);
  });

  useEffect(() => {
    if (!scriptLoaded || !portalToken) return;
    dataRequestLayerUrlRef.current = window.dataRequestFService;
    drFieldsRef.current = window.dataRequestFieldMapping;

    if (!dataRequestLayerUrlRef.current) {
      console.error("Feature service URL not loaded yet");
      return;
    }

    esriId.registerToken({
      server: dataRequestLayerUrlRef.current,
      token: portalToken,
    });

    dataRequestLayerRef.current = new FeatureLayer({
      url: dataRequestLayerUrlRef.current,
    });

  }, [scriptLoaded, portalToken]);



  // const interceptorAdded = useRef(false);
  // const token = localStorage.getItem("PortalToken");

  /**load the global config files required for this module */
  // useScripts([`${process.env.PUBLIC_URL}/config/EnviroportalConfig.js`], () => {
  //   setScriptLoaded(true);
  //   //global variables
  //   dataRequestLayerUrl = window.dataRequestFService;
  //   drFields = window.dataRequestFieldMapping;

  //   if (portalToken && dataRequestLayerUrl) {
  //     try {
  //       esriId.registerToken({
  //         server: dataRequestLayerUrl,
  //         portalToken,
  //       });
  //     } catch (err) {
  //       console.error("Failed to register token:", err);
  //     }
  //   }

  //   dataRequestLayer = new FeatureLayer({
  //     url: dataRequestLayerUrl,
  //   });
  //   //setPortalToken(window.portalToken);
  // });

  // useEffect(() => {
  //   if (!scriptLoaded) return;

  //   //if (portalToken) {
  //   // const token = portalToken;

  //   dataRequestLayer = new FeatureLayer({
  //     url: dataRequestLayerUrl,
  //   });

  //   const escapedBase = window.dataRequestBaseUrl.replace(/\//g, "\\/");
  //   const regex = new RegExp(`${escapedBase}.+\\/FeatureServer(\\/\\d+)?(\\/\\w+)?`, "i");

  //   // esriConfig.request.interceptors.push({
  //   //   urls: regex,
  //   //   // use the BeforeInterceptorCallback to add token to query
  //   //   before: function (params) {
  //   //     if (params && params.requestOptions) {
  //   //       params.requestOptions.query = {
  //   //         ...params.requestOptions.query,
  //   //         token
  //   //       };
  //   //     }
  //   //   },
  //   // });
  //   // }

  //   // interceptorAdded.current = true;
  // }, [scriptLoaded, portalToken]);

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value, 10);
    setPageSize(newSize);
    setFilter((prevFilter) => ({
      ...prevFilter,
      pageSize: newSize,
      pageNumber: 1,
    }));
    if (dataRequestLayerRef.current) {
      getRequestedDetails(1, newSize, filter.sortBy, filter.sortOrder);
    }
  };

  const handlePageChange = (newPageNumber) => {
    setFilter((prevFilter) => ({
      ...prevFilter,
      pageNumber: newPageNumber,
    }));
    if (dataRequestLayerRef.current) {
      getRequestedDetails(newPageNumber, pageSize, filter.sortBy, filter.sortOrder);
    }
  };
  useEffect(() => {
    if (!mapview) return;

    if (AOItype === "1") {
      setSelectedMapservice("");
      setSelectedMapservice(null);
      setSelectedLayers([]);
      setMapLayers([]);
      setFilter({ startDate: "", endDate: "" });
      setEmail("");
      setPurpose("");
      aoiLayer.current?.graphics.removeAll();
      setFiles([]);
      setAOIaddedToMap(false);
      drawOnMap();
    } else if (AOItype === "2") {
      setSelectedMapservice("");
      setSelectedMapservice(null);
      setSelectedLayers([]);
      setMapLayers([]);
      setFilter({ startDate: "", endDate: "" });
      setEmail("");
      setPurpose("");
      aoiLayer.current?.graphics.removeAll();
      setFiles([]);
      setAOIaddedToMap(false);
      drawTool?.cancel();
    } else {
      drawTool?.cancel();
    }


  }, [AOItype, mapview]);

  useEffect(() => {
    if (dataRequestLayerRef.current) {
      getRequestedDetails()
    }

    return () => {
      handleClear();
    };
  }, []);

  const handleCloseDetails = () => {
    setShowReqDetails(false); // Go back to list while preserving filters
  };
  const handleReqClick = (id, status) => (e) => {
    setShowReqDetails(true);
    setReqId(id);
    Setstatus(status);
  };

  const columns = useMemo(
    () => [
      {
        Header: t("requestID"),
        accessor: "objectid",
      },
      {
        Header: t("Data"),
        accessor:
          i18n.language === "en" ? "enmapservicename" : "armapservicename",
      },
      {
        Header: t("requestedDate"),
        accessor: "requesteddate",
        sortMethod: (a, b) => new Date(a) - new Date(b),
        Cell: (props) => (
          <span>
            {new Date(props.value).toLocaleDateString("en-GB")}{" "}
            {new Date(props.value).toLocaleTimeString("en-GB")}
          </span>
        ),
      },
      // {
      //   Header: t("requesterName"),
      //   accessor: "requestedby",
      // },
      // {
      //   Header: t("Updated By"),
      //   accessor: "updatedby",
      // },
      // {
      //   Header: t("Updated Date"),
      //   accessor: "updateddate",
      //   sortMethod: (a, b) => new Date(a) - new Date(b),
      //   Cell: (props) => (
      //     <span>
      //       {props.value
      //         ? `${new Date(props.value).toLocaleDateString(
      //           "en-GB"
      //         )} ${new Date(props.value).toLocaleTimeString("en-GB")}`
      //         : ""}
      //     </span>
      //   ),
      // },
      {
        Header: t("Status"),
        accessor: "status",
        Cell: ({ value }) => (
          <span
            className={`dataReqStatus ${value === "New"
              ? "bg-new"
              : value === "Pending"
                ? "bg-pending"
                : value === "Approved"
                  ? "bg-approved"
                  : "bg-rejected"
              }`}
          >
            {value}
          </span>
        ),
      },
      {
        Header: t("actions"),
        accessor: "actions",
        disableSortBy: true,
        Cell: ({ row }) => (
          <div>
            <div
              onClick={handleReqClick(
                row.original.objectid,
                row.original.status
              )}
              className="mx-2 dataRevActions"
            >
              {row.original.status === "Approved" || row.original.status === "Pending" || row.original.status === "Rejected" ? (
                <div title={t("view")}>
                  <IoEyeOutline size={23} className="" color="#747474" />
                </div>
              ) : (
                <div title={t("edit")}>
                  <FiEdit2 size={20} className="color-black-icon" />
                </div>
              )}
            </div>
          </div>
        ),
      },
    ],
    [t]
  );
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    state: { pageIndex, sortBy },
  } = useTable(
    {
      columns,
      data: dataRequests,
      initialState: {
        pageIndex: filter.pageNumber - 1,
        pageSize: filter.pageSize,
        sortBy: [{ id: "requesteddate", desc: true }],
      },
      manualSortBy: true,
      manualPagination: true,
      pageCount: Math.ceil(totalRecords / pageSize),
      autoResetSortBy: false,
      disableMultiSort: true,
      disableSortRemove: true,
    },
    useSortBy,
    usePagination
  );

  useEffect(() => {
    const sortedColumn = sortBy[0]?.id || "ID";
    const sortOrder = sortBy[0]?.desc ? "desc" : "asc";
    if (dataRequestLayerRef.current) {
      getRequestedDetails(
        filter.pageNumber,
        pageSize,
        columnMapping[sortedColumn],
        sortOrder
      );
    }

  }, [filter.pageNumber, pageSize, sortBy]);

  useEffect(() => {
    gotoPage(filter.pageNumber - 1);
  }, [filter.pageNumber, gotoPage]);

  useEffect(() => {
    setPageSize(filter.pageSize);
  }, [filter.pageSize, setPageSize]);
  const getQueryFilter = () => {
    const conditions = [];
    const userEmail = localStorage.getItem("Email");

    let _filter;
    if (drFilter?.where !== "") {
      _filter = { ...drFilter };
    } else {
      _filter = { ...filter };
    }

    if (_filter.status) {
      conditions.push(`status = '${_filter.status}'`);
    }

    if (_filter.startDate && !_filter.endDate) {
      conditions.push(`requesteddate >= '${_filter.startDate}'`);
    }
    if (_filter.endDate && !_filter.startDate) {
      conditions.push(`requesteddate <= '${_filter.endDate}'`);
    }
    if (_filter.startDate && _filter.endDate) {
      conditions.push(
        `requesteddate >= '${_filter.startDate}' AND requesteddate <= '${_filter.endDate}'`
      );
    }
    if (userEmail) {
      conditions.push(`requestedby = '${userEmail}'`);
    }
    const queryWhere = conditions.length
      ? `(${conditions.join(" AND ")})`
      : `1=1`;
    return queryWhere;
  };
  const getRequestedDetails = async (pageNumber = 1,
    pageSize = DEFAULT_PAGE_SIZE,
    sortBy = "requesteddate", //"id",
    sortOrder = "desc", //"asc"
    queryFilter = null) => {    
      // Define the Query object
      const userEmail = localStorage.getItem("Email");
      const requestsQuery = {
        where: queryFilter ? queryFilter : getQueryFilter(),
        objectIds: filter.requestID ? [filter.requestID] : [],
        outFields: ["*"],
        returnGeometry: false,
        start: (pageNumber - 1) * pageSize,
        num: pageSize,
        orderByFields: [`${sortBy} ${sortOrder}`],
      };
      // console.log('getting data requests where: ', requestsQuery.where);
      // console.log('start, num', requestsQuery.start, requestsQuery.num);
      const countQuery = new Query();
      countQuery.where = requestsQuery.where || `requestedby = '${userEmail}'`;
      countQuery.returnCountOnly = true;
      const countResult = await dataRequestLayerRef.current.queryFeatures(countQuery);
      const total = countResult.features.length
      try {
        // Execute query
        const response = await dataRequestLayerRef.current.queryFeatures(requestsQuery);
        const features = response.features.map((feature) => {
          return {
            ...feature.attributes,
          };
        });
        setDataRequests(features || []);
        setNoResults((features || []).length === 0);
        setTotalRecords(total || 0);
      } catch (error) {
        console.error("Error executing query:", error);
      }    
  };
  const drawOnMap = () => {
    let sketch = new Sketch({
      layer: aoiLayer.current,
      view: mapview,
      creationMode: "single",
      // viewModel: {
      tooltipOptions: {
        enabled: true,
        helpMessage: "Click to draw AOI",
        visibleElements: {
          helpMessage: true,
        },
      },
    });
    sketch.create("polygon", { mode: "click" });
    mapview.map.add(aoiLayer.current);
    sketch.on("create", function (event) {
      if (event.state === "complete") {
        aoiLayer.current.graphics.removeAll();
        const graphic = event.graphic;
        addGraphicsToLayer(aoiLayer.current, [graphic]);
        setAOIaddedToMap(true);
        setAOI(graphic);
        setEmail(getLocalStorageItem("Email") || "");
      }
    });
    setDrawTool(sketch);
  };

  useImperativeHandle(
    ref,
    () => ({
      cancelDrawTool: () => {
        if (drawTool) {
          drawTool?.cancel(); // Call cancel method on Sketch tool
        } else {
          // console.warn("No draw tool available to cancel");
        }
        setDrawTool(null);
      },
    }),
    [drawTool]
  ); // Add drawTool as a dependency

  const fetchMapServices = async () => {
    try {
      const userID = parseInt(getLocalStorageItem("UserId"), 10) || 0; /**handles all edge cases(null, undefined, invalid or empty values) */
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/DataExtraction/mapServices/${userID}`,
        {
          method: "GET",
        }
      );
      if (!response.ok) {
        const errorText = await response.json();
        throw new Error(`${response.status}: ${errorText.message}`);
      }
      const data = await response.json();
      setMapservices(data);
    } catch (error) {
      return { data: null, error: error.message };
    }
  };

  useEffect(() => {
    fetchMapServices();
  }, []);

  const fetchMapLayers = async (mapServiceID) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/DataExtraction/mapLayers/${mapServiceID}`,
        {
          method: "GET",
        }
      );
      if (!response.ok) {
        const errorText = await response.json();
        throw new Error(`${response.status}: ${errorText.message}`);
      }
      const data = await response.json();
      return { data, error: null };
    } catch (error) {
      return { data: null, error: error.message };
    }
  };

  const handleMapServiceChange = async (evt) => {
    const selection = evt.value;
    if (selection !== "") {
      setSelectedMapservice(selection);
      let result = await fetchMapLayers(selection);
      if (result.error) {
        showAlert(result.error, "error");
      } else {
        const mapLayers = result.data;
        setMapLayers(mapLayers);
        setSelectedLayers([]);
      }
    }
  };

  const handleLayerChange = (layerId) => {
    setSelectedLayers((prevSelectedLayers) =>
      prevSelectedLayers.includes(layerId)
        ? prevSelectedLayers.filter((id) => id !== layerId)
        : [...prevSelectedLayers, layerId]
    );
  };

  useEffect(() => {
    if (!selectedLayers?.length) return;

    /**check if layers have tabular data */
    let layerNames = getLayerNames(selectedLayers.join(","));
    layerNames = layerNames.split(",").map((layer) => layer.trim());
    const tabularDataLayers = Object.keys(window.tabularDataLayers) || [];
    const hasTabularData = layerNames.some((lname) =>
      tabularDataLayers.includes(lname)
    );
    setTabularData(hasTabularData);

  }, [selectedLayers]);

  const handleDateRangeChange = (e) => {
    const { name, value } = e.target;
    const today = new Date().toISOString().split("T")[0];
    if (value > today) {
      showAlert(t("Future dates are not allowed."), "error");
      setFilter((prevFilter) => ({
        ...prevFilter,
        [name]: "",
      }));
      return;
    }
    else {
      setFilter((prevFilter) => ({
        ...prevFilter,
        [name]: value,
      }));
    }
  };

  const validateDates = (_filter) => {
    const newErrors = {};
    const currentDate = new Date();
    const startDateVal = new Date(_filter.startDate);
    const endDateVal = new Date(_filter.endDate);

    if (!startDateVal) {
      // newErrors.startDate = t("pleaseSelectStartDate");
      newErrors.startDate = "";
    } else if (startDateVal > currentDate) {
      newErrors.startDate = t("startDateCannotBeInTheFuture");
    } else if (startDateVal > endDateVal) {
      newErrors.startDate = t("startDateCannotBeAfterEndDate");
    } else {
      newErrors.startDate = "";
    }

    if (!endDateVal) {
      // newErrors.endDate = t("pleaseSelectEndDate");
      newErrors.endDate = "";
    } else if (endDateVal > currentDate) {
      newErrors.endDate = t("endDateCannotBeInTheFuture");
    } else {
      newErrors.endDate = "";
    }

    setErrors((prevErrors) => ({ ...prevErrors, ...newErrors }));
    return (
      Object.keys(newErrors).filter((key) => newErrors[key] !== "").length === 0
    );
  };

  const validEmail = () => {
    const errors = {};
    errors.email = validateEmail(t, email, false);
    setErrors((prevErrors) => ({ ...prevErrors, ...errors }));
    return Object.keys(errors).filter((key) => errors[key] !== "").length === 0;
  };

  const toISOStringOrNull = (value) => {
    const date = new Date(value);
    return isNaN(date.getTime()) ? null : date.toISOString();
  };

  const getLayerNames = (layerIDs) => {
    let layerNames = layerIDs;
    const layerIDsArray = layerIDs.split(",").map(id => parseInt(id.trim(), 10));
    layerNames = maplayers.filter((layer) => layerIDsArray.includes(layer.id))
      .map((layer) => layer.layerName);
    return layerNames.length > 0 ? layerNames.join(", ") : layerIDs;
  };

  const sendEmails = async (result) => {
    try {
      const drFields = drFieldsRef.current;
      const payload = {
        ID: result[drFields.requestID],
        MapServiceID: result[drFields.mapServiceID],
        EnMapServiceName: result[drFields.enMapServiceName],
        ArMapServiceName: result[drFields.arMapServiceName],
        LayerIDs: getLayerNames(result[drFields.layerIDs]),
        FromDate: toISOStringOrNull(result[drFields.fromDate]),
        ToDate: toISOStringOrNull(result[drFields.toDate]),
        Purpose: result[drFields.purpose],
        Status: result[drFields.status],
        RequestedBy: result[drFields.requestedBy],
        RequestedDate: toISOStringOrNull(result[drFields.requestedDate]),
      };

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/DataExtraction/NotifyNewDataRequest`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );
      if (!response.ok) {
        const errorText = await response.json();
        throw new Error(`${response.status}: ${errorText.message}`);
      }
      return response.json();
    } catch (error) {
      throw new Error("Email sending failed");
    }
  };

  const featuresExistInAOI = async () => {
    if (!selectedLayers?.length) return;

    showLoading(true);

    const fetchFeatures = async () => {
      allSelectedResults = []
      /**get selected layers */
      const _layers = maplayers.filter((layer) => selectedLayers.includes(layer.id));
      /**Create an array of promises for querying layers */
      const queryPromises = _layers.map(async (layer) => {
        const featureLayer = new FeatureLayer({ url: layer.mapServiceUrl });
        const query = new Query();
        query.geometry = AOI.geometry;
        query.spatialRelationship = "intersects";
        query.outFields = ["*"];
        query.returnGeometry = true;

        const layerHasTabularData = (Object.keys(window.tabularDataLayers)).some(name => name === layer.layerName);
        if (layerHasTabularData) {
          let conditions = [];
          const dateFieldName = window.tabularDataLayers[layer.layerName].dateField;
          if (filter.startDate && !filter.endDate) {
            conditions.push(`${dateFieldName} >= '${filter.startDate}'`);
          }
          if (filter.endDate && !filter.startDate) {
            conditions.push(`${dateFieldName} <= '${filter.endDate}'`);
          }
          if (filter.startDate && filter.endDate) {
            conditions.push(
              `${dateFieldName} >= '${filter.startDate}' AND ${dateFieldName} <= '${filter.endDate}'`
            );
          }
          const queryWhere = conditions.length
            ? `(${conditions.join(" AND ")})`
            : `1=1`;
          query.where = queryWhere;
        }

        try {
          const result = await featureLayer.queryFeatures(query);
          if (result.features.length > 0) {
            allSelectedResults.push(...result.features); // Push feature
          } else {
            console.log(`No features found in requested layer "${layer.layerName}"`);
          }
        } catch (error) {
          console.log("Error querying features from layer:", layer.mapServiceUrl, error);
        }
      });

      await Promise.all(queryPromises);
      return allSelectedResults.length > 0;
    };
    const hasFeatures = await fetchFeatures();
    // console.log("Has features in AOI:", hasFeatures);
    if (!hasFeatures) {
      showUpdationModal(t("noFeaturesInRequestedArea"), "warning");
      showLoading(false);
    }
    return hasFeatures;
  }

  const submitDataRequest = async () => {
    if (validEmail() && validateDates(filter) && await featuresExistInAOI()) {
      try {
        /**use feature service */
        showLoading(true);
        const drFields = drFieldsRef.current;
        const enMapserviceName = mapservices.find(
          (x) => x.id === parseInt(selectedMapservice)
        ).enMapServiceName;
        const arMapserviceName = mapservices.find(
          (x) => x.id === parseInt(selectedMapservice)
        ).arMapServiceName;
        const dataRequestGraphic = new Graphic({
          geometry: AOI.geometry,
          attributes: {
            [drFields.mapServiceID]: parseInt(selectedMapservice),
            [drFields.enMapServiceName]: enMapserviceName,
            [drFields.arMapServiceName]: arMapserviceName,
            [drFields.layerIDs]: selectedLayers.join(","),
            // [drFields.layerIDs]: selectedLayerNames.join(","),
            [drFields.fromDate]: new Date(filter.startDate).getTime(),
            [drFields.toDate]: new Date(filter.endDate).getTime(),
            [drFields.purpose]: purpose,
            [drFields.status]: "Pending",
            [drFields.requestedBy]: localStorage.getItem("Email"),
            [drFields.requestedDate]: new Date().getTime(),
            [drFields.email]: email,
          },
        });
        const editsResult = await dataRequestLayerRef.current.applyEdits({
          addFeatures: [dataRequestGraphic],
        });

        if (editsResult.addFeatureResults.length > 0) {
          await attachShapefileToFeature(editsResult.addFeatureResults[0].objectId, dataRequestGraphic.attributes);


          // Upload PDF if available (only for AOItype === "1")
          if (files.length > 0 && AOItype === "1") {
            const pdfFile = files[0];
            if (pdfFile && pdfFile.name.toLowerCase().endsWith('.pdf')) {
              await uploadShapefile(pdfFile, editsResult.addFeatureResults[0].objectId, pdfFile.name, "");
            }
          }

          handleClear();
          await sendEmails({
            ...dataRequestGraphic.attributes,
            [drFields.requestID]: editsResult.addFeatureResults[0].objectId,
            [drFields.requestedBy]: email
          });
          showUpdationModal(
            t("dataRequestSubmitSuccess"),
            "success",
            navigate,
            "/"
          );
        } else {
          throw new Error("Error applying edits");
        }
      } catch (error) {
        showUpdationModal(t("dataRequestSubmitFail"), "error");
      } finally {
        showLoading(false);
      }
    }
  };
  const normalizeAttributes = (features) => {
    let allKeys = new Set();

    // Collect all unique keys
    features.forEach(feature => {
      Object.keys(feature.properties).forEach(key => allKeys.add(key));
    });

    // Standardize attributes for all features
    return features.map(feature => {
      let newProperties = {};
      allKeys.forEach(key => {
        newProperties[key] = feature.properties[key] || null; // Fill missing attributes with null
      });
      return { ...feature, properties: newProperties };
    });
  };
  // const attachShapefileToFeature = async (objectId, attributes) => {

  //   if (!aoiLayer.current || aoiLayer.current.graphics.length === 0) {
  //     console.log("No graphics found to process.");
  //     return;
  //   }

  //   const filename = attributes.enmapservicename;

  //   const geojsonFeatures = [];
  //   aoiLayer.current.graphics.forEach(graphic => {
  //     const geometry = arcgisToGeoJSON(graphic.geometry);
  //     if (geometry && geometry.type) {
  //       geojsonFeatures.push({
  //         type: "Feature",
  //         geometry: geometry,
  //         properties: attributes || {} // Keep attributes
  //       });
  //     } else {
  //       console.warn("Invalid geometry found in graphic:", graphic);
  //     }
  //   });
  //   if (geojsonFeatures.length === 0) {
  //     console.error("No valid features found.");
  //     return;
  //   }

  //   // Normalize attributes for uniform structure
  //   const normalizedFeatures = normalizeAttributes(geojsonFeatures);


  //   // Convert to Shapefile and Upload
  //   convertToShapefile(normalizedFeatures, filename, (zipBlob) => {
  //     uploadShapefile(zipBlob, objectId, filename);
  //   });
  // };

  const attachShapefileToFeature = async (objectId, attributes) => {
    if (allSelectedResults.length === 0) {
      console.log("No features found in requested layers.");
      return Promise.resolve(); // Return resolved promise for consistency
    }

    return new Promise((resolve, reject) => {
      let promises = [];
      const filename = attributes.enmapservicename;

      try {
        const worker = new Worker(
          new URL("../../enviroportal/components/DataExport/geoJsonWorker.js", import.meta.url),
          { type: "module" }
        );

        const workerPromise = new Promise(async (innerResolve, innerReject) => {
          worker.onmessage = (e) => {
            if (e.data.success) {
              const geojson = e.data.geojson;
              const normalizedFeatures = normalizeAttributes(geojson.features);
              innerResolve(normalizedFeatures);
            } else {
              console.error("Error in worker:", e.data.error);
              innerReject(e.data.error);
            }
            worker.terminate();
          };

          worker.onerror = (error) => {
            console.error("Worker error:", error);
            innerReject(error);
            worker.terminate();
          };

          var filteredFeatures = await getFeaturesByFilter(allSelectedResults)
          worker.postMessage(filteredFeatures);
        });

        promises.push(workerPromise);

        Promise.all(promises)
          .then((normalizedFeatures) => {
            convertToShapefile(normalizedFeatures, filename, async (shapefileBlob) => {
              try {
                await uploadShapefile(shapefileBlob, objectId, filename, ".zip");
                resolve(); // Resolve when everything is complete
              } catch (error) {
                reject(error);
              }
            });
          })
          .catch(error => {
            console.error("Error in shapefile generation process:", error);
            reject(error);
          });
      } catch (error) {
        console.error("Error in shapefile generation process:", error);
        reject(error);
      }
    });
  };
  // Make uploadShapefile return a Promise
  function uploadShapefile(zipBlob, objectId, filename, fileType) {
    return new Promise((resolve, reject) => {
      let formData = new FormData();
      formData.append("attachment", zipBlob, filename + fileType);
      formData.append("f", "json");

      //let featureServiceUrl = dataRequestLayerUrl;
      let featureServiceUrl = dataRequestLayerUrlRef.current;
      let addAttachmentUrl = `${featureServiceUrl}/${objectId}/addAttachment`;

      esriRequest(addAttachmentUrl, {
        method: "post",
        body: formData
      }).then((response) => {
        resolve(response); // Resolve when upload is complete
      }).catch((error) => {
        showUpdationModal(t("attachmentFailed"), "warning");
        console.error("Attachment failed:", error);
        reject(error);
      });
    });
  }

  const handleClear = () => {
    setSelectedMapservice("");
    setSelectedMapservice(null);
    setSelectedLayers([]);
    setMapLayers([]);
    setFilter({ startDate: "", endDate: "" });
    setEmail("");
    setPurpose("");
    setAOItype("");
    aoiLayer.current?.graphics.removeAll();
    setFiles([]);
    setAOIaddedToMap(false);
  };

  const handleSelectChange = (event) => {
    let selectedFormat = event.value;
    setSelectedFileType(selectedFormat);
    setErrors((prevErrors) => ({ ...prevErrors, ...{ validFile: "" } }));
  };
  const handleFilterReset = () => {
    setDrFilter({
      startDate: "",
      endDate: "",
      status: "",
      where: ""
    });
    getRequestedDetails(1, pageSize, filter.sortBy, filter.sortOrder);
  }

  const handleSearch = (e) => {
    const newSize = DEFAULT_PAGE_SIZE;

    // fetchDataRequests(1, newSize, filter.sortBy, filter.sortOrder);
    // Destructure filter values
    const { startDate, endDate, status } = drFilter;

    // Check if all fields are empty
    if (!startDate && !endDate && !status) {
      showAlert(t("atleastOneFilterField"), "error");
      return; // Exit if no filters are provided
    }

    if (validateDates(drFilter) === false) {
      return;
    }

    setFilter((prevFilter) => ({
      ...prevFilter,
      pageSize: newSize,
      pageNumber: 1,
    }));
    setFilterVisible(false);
    const drWhere = getQueryFilter(drFilter);
    setDrFilter((prevFilter) => ({
      ...prevFilter,
      where: drWhere,
    }));
    getRequestedDetails(1, newSize, filter.sortBy, filter.sortOrder, drWhere);
  };
  const handleStatusChange = (e) => {
    setDrFilter((prevFilter) => ({
      ...prevFilter,
      status: e.label,
    }));
    setFilter((prevFilter) => ({
      ...prevFilter,
      status: e.label,
      pageNumber: 1,
    }));
    gotoPage(0);
  };


  const handlebrowse = () => {
    if (externalFileRef.current) {
      externalFileRef.current.click();
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const droppedFiles = Array.from(e.dataTransfer.files);
    //handleFiles(droppedFiles);
    setFiles([...files, ...droppedFiles]);
    const FileDropped = {
      target: {
        files: droppedFiles,
        value: droppedFiles[0]?.name || "",
      },
    };

    // Call your existing file upload function
    fileUploadonchange(FileDropped);
  };

  const handleFiles = (files) => {
    const fileList = document.getElementById("fileList");
    fileList.innerHTML = "";
    for (let i = 0; i < files.length; i++) {
      let file = files[i];
      let listItem = document.createElement("div");
      listItem.classList.add("alert-info", "mb-2");
      let fileName = DOMPurify.sanitize(file.name);
      //listItem.textContent = `File: ${file.name}`;
      listItem.textContent = `File: ${fileName}`;
      fileList.appendChild(listItem);
    }
  };
  const convertkmlorkmz = async (input_file) => {
    if (input_file.name.endsWith(".kml")) {
      const kmlString = await input_file.text();
      const parser = new DOMParser();
      const kml = parser.parseFromString(kmlString, "text/xml");
      const geojson = toGeoJSON.kml(kml);
      Addkmzorkmltomap(geojson);
    } else if (input_file.name.endsWith(".kmz")) {
      const zip = await JSZip.loadAsync(input_file);
      const kmlFile = zip.file(/.kml$/i)[0];
      const kmlString = await kmlFile.async("string");
      const parser = new DOMParser();
      const kml = parser.parseFromString(kmlString, "text/xml");
      const geojson = toGeoJSON.kml(kml);
      Addkmzorkmltomap(geojson);
    }
  };

  const generateFeatureCollection = async (file) => {
    let selectedfeatures = [];
    const zip = await JSZip.loadAsync(file);
    const files = {};
    await Promise.all(
      Object.keys(zip.files).map(async (filename) => {
        const ext = filename
          .split(".")
          .pop()
          .toLowerCase();
        if (["shp", "shx", "dbf", "prj"].includes(ext)) {
          files[filename] = await zip.files[filename].async("arraybuffer");
        }
      })
    );

    // Extract base name from the first shapefile found in the zip
    const shapefileBaseName = Object.keys(files)
      .find((filename) => filename.endsWith(".shp"))
      .split(".shp")[0];

    // Open the shapefile and its corresponding dbf file
    shapefile
      .open(
        files[`${shapefileBaseName}.shp`],
        files[`${shapefileBaseName}.dbf`]
      )
      .then((source) =>
        source.read().then(function log(result) {
          if (result.done) {
            addShapefileToMap(selectedfeatures, shapefileBaseName);
            return;
          }
          const geometryType = result.value.geometry.type.toLowerCase();
          let geometry;

          if (geometryType === "polygon") {
            geometry = {
              type: "polygon",
              rings: result.value.geometry.coordinates,
            };
          } else if (geometryType === "point") {
            geometry = {
              type: "point",
              longitude: result.value.geometry.coordinates[0],
              latitude: result.value.geometry.coordinates[1],
            };
          } else if (
            geometryType === "polyline" ||
            geometryType === "linestring"
          ) {
            geometry = {
              type: "polyline",
              paths: result.value.geometry.coordinates,
            };
          } else if (geometryType === "multipoint") {
            geometry = {
              type: "multipoint",
              points: result.value.geometry.coordinates,
            };
          }

          if (geometry) {
            selectedfeatures.push({
              type: geometryType,
              geometry: geometry,
              symbol: getSymbol(geometryType),
              attributes: result.value.properties,
            });
          }

          return source.read().then(log);
        })
      )
      .catch((error) => console.log(error));
  };

  const addShapefileToMap = (selectedfeatures, fileBaseName) => {
    aoiLayer.current.title = fileBaseName;
    mapview.map.findLayerById("AOILayer")?.remove();
    mapview.map.add(aoiLayer.current);
    aoiLayer.current?.graphics.removeAll();

    for (var i = 0; i < selectedfeatures.length; i++) {
      var feature = selectedfeatures[i];
      var infoWindowContent = "<table>";
      for (var property in feature.attributes) {
        if (
          feature.attributes.hasOwnProperty(property) &&
          property.toLowerCase().indexOf("doc") === -1
        ) {
          infoWindowContent +=
            "<tr><td>" +
            property +
            ":</td><td>" +
            feature.attributes[property] +
            "</td></tr>";
        }
      }
      infoWindowContent += "</table>";

      var infoTemplate = new PopupTemplate("Details", infoWindowContent);
      var graphic = new Graphic({
        geometry: feature.geometry,
        symbol: feature.symbol,
        attributes: feature.attributes,
        popupTemplate: infoTemplate,
      });
      setAOI(graphic);
      aoiLayer.current.graphics.add(graphic);
    }
    const graphicsExtent = calculateGraphicsExtent(
      aoiLayer.current.graphics.items
    );
    if (graphicsExtent) {
      mapview.goTo(graphicsExtent.expand(1.2)); // expand by 20% for better view
      setAOIaddedToMap(true);
    }
  };

  const Addkmzorkmltomap = (geojsonData, fileBaseName) => {
    aoiLayer.current.title = fileBaseName;
    mapview.map.findLayerById("AOILayer")?.remove();
    mapview.map.add(aoiLayer.current);
    aoiLayer.current?.graphics.removeAll();

    if (geojsonData) {
      geojsonData.features.forEach(function (feature) {
        var kmlsymbol = {};
        var graphic;
        if (feature.geometry.type.toLowerCase() === "point") {
          kmlsymbol = { type: "simple-marker" };
          var geometry = {
            type: "point",
            longitude: feature.geometry.coordinates[0],
            latitude: feature.geometry.coordinates[1],
          };
          var symbol = { type: "simple-marker" };
          graphic = new Graphic({
            geometry: geometry,
            symbol: symbol,
            attributes: feature.properties,
            popupTemplate: {
              title: "{name}",
              content: "Coordinates: [{longitude}, {latitude}]",
            },
          });
          aoiLayer.current.graphics.add(graphic);
          setAOI(graphic);
        } else if (
          feature.geometry.type.toLowerCase() === "polyline" ||
          feature.geometry.type.toLowerCase() === "linestring"
        ) {
          kmlsymbol = { type: "simple-line" };

          graphic = new Graphic({
            geometry: {
              type: "polyline",
              paths: feature.geometry.coordinates,
            },
            symbol: kmlsymbol,
            attributes: feature.properties,
            popupTemplate: {
              title: "{name}",
              content: `Coordinates: ${feature.geometry.coordinates}`,
            },
          });
          aoiLayer.current.graphics.add(graphic);
          setAOI(graphic);
        } else if (feature.geometry.type.toLowerCase() === "polygon") {
          kmlsymbol = { type: "simple-fill" };
          graphic = new Graphic({
            geometry: {
              type: "polygon",
              rings: feature.geometry.coordinates,
            },
            symbol: kmlsymbol,
            attributes: feature.properties,
            popupTemplate: {
              title: "{name}",
              content: `Coordinates: ${feature.geometry.coordinates}`,
            },
          });
          aoiLayer.current.graphics.add(graphic);
          setAOI(graphic);
        }
      });
      const graphicsExtent = calculateGraphicsExtent(
        aoiLayer.current.graphics.items
      );
      if (graphicsExtent) {
        mapview.goTo(graphicsExtent.expand(1.2)); // expand by 20% for better view
        setAOIaddedToMap(true);
      }
    }
  };

  const fileUploadonchange = (e) => {
    let selectedFormat = selectedFileType;
    if (selectedFormat) {
      let errors = {};
      let fileFullName = e.target.value;
      let fileNameArr = fileFullName.split("\\");
      let fileName = fileNameArr[fileNameArr.length - 1];
      let fileExtArr = fileName.split(".");
      let fileExt = "." + fileExtArr[fileExtArr.length - 1];
      let validFile = false;
      if (AOItype == "1") {
        // Draw Tab: Handle PDF files only with size greater than 2MB
        const uploadedFile = e.target.files[0];
        const fileSizeInBytes = uploadedFile.size;
        const fileSizeInMB = fileSizeInBytes / (1024 * 1024);

        if (fileExt.toLowerCase() !== ".pdf") {
          errors.validFile = t("Only PDF files are allowed.");
        } else if (fileSizeInMB > 2) {
          errors.validFile = t("File size should not be greater than 2 MB.");
        } else {
          validFile = true;
        }

        if (validFile) {
          handleFiles(e.target.files);
          const selectedFiles = Array.from(e.target.files);
          setFiles([...files, ...selectedFiles]);
          setErrors((prevErrors) => ({ ...prevErrors, ...{ validFile: "" } }));
        } else {
          setErrors((prevErrors) => ({ ...prevErrors, ...errors }));
        }
      }
      else {
        switch (selectedFormat) {
          case "kml":
            if (
              fileExt.toLowerCase() === ".kml" ||
              fileExt.toLowerCase() === ".kmz"
            ) {
              convertkmlorkmz(e.target.files[0]);
              validFile = true;
            } else {
              errors.validFile = t("invalidkmz");
            }

            break;
          case "shp":
            if (fileExt.toLowerCase() === ".zip") {
              generateFeatureCollection(e.target.files[0]);
              validFile = true;
            } else {
              errors.validFile = t("InvalidShape");
            }
            break;
          default:
            break;
        }
        if (validFile) {
          handleFiles(e.target.files);
          const selectedFiles = Array.from(e.target.files);
          setFiles([...files, ...selectedFiles]);
          setErrors((prevErrors) => ({ ...prevErrors, ...{ validFile: "" } }));
        } else {
          setErrors((prevErrors) => ({ ...prevErrors, ...errors }));
        }
      }

    }
  };

  const handleAOITypeChange = (value) => {
    setAOItype((prevAOItype) => {
      return prevAOItype === value ? "" : value;
    });
    const fileList = document.getElementById("fileList");
    fileList.innerHTML = "";
  };

  const onFilterClick = () => {
    setFilterVisible(!filterVisible);
  };

  // const toggleDataSection = () => {
  //   setShowDataSection(!showDataSection);
  //   setFilterVisible(false);
  // };

  const [activeTab, setActiveTab] = useState("ViewRequestedData");

  useEffect(() => {
    if (!email) return;
    /**validate email whenever value changes */
    validEmail();
  }, [email]);

  useEffect(() => {
    if (!filter) return;
    if (filter.startDate && filter.endDate) {
      validateDates(filter);
    }
  }, [filter]);
  const mapserviceoptions = mapservices.map((ms) => ({
    value: ms.id, // The value for react-select is the map service id
    label: i18n.language === "en" ? ms.enMapServiceName : ms.arMapServiceName, // The label is either the English or Arabic name
  }));
  const options = [
    { value: "shp", label: t("Shapefile") },
    { value: "kml", label: t("KML") },
  ];
  if (fetchOnly) return null;
  return (
    <DataRequestContext.Provider
      value={{
        //setMapview,
        mapview,
        showLoading,
        loading,
      }}
    >
      {scriptLoaded ? (
        <Fragment>
          <div className="dem-sidebar req-htScroll">
            <div className="dataReqTabsAlign mb-2" ref={(el) => { if (el) elementInstances["div1"] = el; }} style={theme === "dark" ? { borderColor: "#fff" } : {}}>
              <div
                className={`tab ${activeTab === "ViewRequestedData" ? "active" : ""}`}
                onClick={() => {
                  if (showReqDetails) {
                    setShowReqDetails(false)
                  }
                  setActiveTab("ViewRequestedData")
                }}
              >
                {t("ViewRequestedData")}
              </div>
              <div
                className={`tab ${activeTab === "RequestData" ? "active" : ""}`}
                onClick={() => setActiveTab("RequestData")}
              >
                {t("RequestData")}
              </div>


            </div>


            {activeTab === "ViewRequestedData" && (
              <div className="showReviewRequestData">
                {showReqDetails ? (
                  <DataRequestFeatureDetails
                    id={reqId}
                    mapview={mapview}
                    approvedstatus={status}
                    onCancel={handleCloseDetails}
                  />
                ) : (
                  <>
                    <div className="filters dataFilterWrp mb-2">
                      <button
                        className="historicalfilter-button justify-content-between mb-2"
                        onClick={onFilterClick}
                      >
                        <span
                          className="filter-text"
                          style={{ color: theme === "dark" ? "#fff" : "#000" }}
                          ref={(el) => { if (el) elementInstances["span"] = el; }}
                        >
                          {t("filter")}
                        </span>
                        <BiFilterAlt
                          className="filter-icon"
                          id="DataRequesticon1"
                          size={15}
                          style={{ color: theme === "dark" ? "#fff" : "#004987" }}
                        />
                      </button>
                    </div>
                    {filterVisible && (
                      <div className="filterContent filterReviewScroll">
                        <div className="filterMob">
                          <div className="filter-header justify-content-end">
                            <RxCross2
                              size={15}
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setFilterVisible(false);
                              }}
                            />
                          </div>
                          <div className="row mb-1">
                            <div className="col-md-12 mb-2">
                              <label
                                htmlFor=""
                                className="form-label mb-1 ms-1"
                              >
                                {t("Start Date")}
                              </label>
                              <input
                                type="date"
                                name="startDate"
                                placeholder={t("Start Date")}
                                className="form-control"
                                value={drFilter.startDate}
                                onChange={(e) => setDrFilter({ ...drFilter, startDate: e.target.value })}
                              />
                            </div>
                            <div className="col-md-12 mb-2">
                              <label
                                htmlFor=""
                                className="form-label mb-1 ms-1"
                              >
                                {t("End Date")}
                              </label>
                              <input
                                type="date"
                                name="endDate"
                                placeholder={t("End Date")}
                                className="form-control"
                                value={drFilter.endDate}
                                onChange={(e) => setDrFilter({ ...drFilter, endDate: e.target.value })}
                                // max={new Date().toISOString().split("T")[0]}//utc time
                                max={new Date().toLocaleDateString('en-CA')}//local time
                                min={drFilter.startDate || ""}
                              />
                            </div>
                            <div className="col-md-12 mb-2">
                              <label
                                htmlFor=""
                                className="form-label mb-1 ms-1 adminModule-label"
                              >
                                {t("Select Status")}
                              </label>

                              <Select
                                name="status"
                                className={`react-select-container`}
                                classNamePrefix="react-select"
                                value={window.dataRequestStatus
                                  .map((drequest) => ({
                                    value: drequest.id,
                                    label: drequest.name,
                                  }))
                                  .find((option) => option.value === drFilter.status) || null}
                                onChange={(e) => handleStatusChange(e)}
                                options={window.dataRequestStatus.map(
                                  (drequest) => ({
                                    value: drequest.id,
                                    label: drequest.name,
                                  })
                                )}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="d-flex gap-2 py-3 pb-0 justify-content-end">
                          <button
                            className="btn btn-outline clearfilter-btn"
                            onClick={handleFilterReset}
                          >
                            {t("reset")}
                          </button>
                          <button
                            className="btn btn-primary custom-btn"
                            onClick={handleSearch}
                          >
                            {t("ApplyFilter")}
                          </button>
                        </div>
                      </div>
                    )}

                    {!filterVisible && dataRequests.length > 0 ? (
                      <>
                        {totalRecords > DEFAULT_PAGE_SIZE && (
                          <Pagination
                            gotoPage={(page) => handlePageChange(page + 1)}
                            previousPage={() =>
                              handlePageChange(filter.pageNumber - 1)
                            }
                            nextPage={() => handlePageChange(filter.pageNumber + 1)}
                            canPreviousPage={canPreviousPage}
                            canNextPage={canNextPage}
                            pageCount={pageCount}
                            pageIndex={pageIndex}
                            pageOptions={pageOptions}
                            pageSize={pageSize}
                            setPageSize={(size) => {
                              setPageSize(size);
                              handlePageSizeChange({ target: { value: size } });
                            }}
                            totalRecords={totalRecords}
                            t={t}
                            DEFAULT_PAGE_SIZE={DEFAULT_PAGE_SIZE}
                          />
                        )}
                        <div className="table-responsive requestDataScrollHt">
                          <table className="table EnvTable mb-0" {...getTableProps()}>
                            <thead className="thead-dark">
                              {headerGroups.map((headerGroup) => {
                                const {
                                  key: headerGroupKey,
                                  ...headerGroupProps
                                } = headerGroup.getHeaderGroupProps();
                                return (
                                  <tr key={headerGroupKey} {...headerGroupProps}>
                                    {headerGroup.headers.map((column) => {
                                      const {
                                        key: columnKey,
                                        ...columnProps
                                      } = column.getHeaderProps(
                                        column.getSortByToggleProps()
                                      );
                                      return (
                                        <th key={columnKey} {...columnProps}>
                                          <SortableHeader column={column} />
                                        </th>
                                      );
                                    })}
                                  </tr>
                                );
                              })}
                            </thead>
                            <tbody {...getTableBodyProps()}>
                              {page.map((row) => {
                                prepareRow(row);
                                const {
                                  key: rowKey,
                                  ...rowProps
                                } = row.getRowProps();
                                return (
                                  <tr key={rowKey} {...rowProps}>
                                    {row.cells.map((cell) => {
                                      const {
                                        key: cellKey,
                                        ...cellProps
                                      } = cell.getCellProps();
                                      return (
                                        <td key={cellKey} {...cellProps}>
                                          {cell.render("Cell")}
                                        </td>
                                      );
                                    })}
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </>
                    ) : (!filterVisible &&
                      // noResults && <NoResults theme={theme} />
                      <div className="requestMsgData mt-3 mb-3">
                        <h3 className="mb-0">{t("RequestedDataContent")}</h3>
                      </div>
                    )}
                  </>
                )}


                {/* Content Section */}

              </div>
            )}


            {activeTab === "RequestData" && (
              <>
                <div className="inputs">
                  <div className="choose-aoi mb-1 form-group mt-1">
                    <span className="text-danger">*</span>{" "}
                    <label className="form-label mb-2 me-4">
                      {" "}
                      {t("chooseAOI")}
                    </label>
                    {"   "}{" "}
                    {mapview && (
                      <ButtonGroup>
                        {radios.map((radio, idx) => (
                          <ToggleButton
                            key={idx}
                            id={`radio-${idx}`}
                            type="radio"
                            variant={"outline-primary"}
                            className="EnvitoSwitch-icon dataRevIcoBtn"
                            name="radio"
                            value={radio.value}
                            checked={AOItype === radio.value}
                            onClick={() => handleAOITypeChange(radio.value)}
                          >
                            {radio.icon} {t(`${radio.name}`)}
                          </ToggleButton>
                        ))}
                      </ButtonGroup>
                    )}
                    {AOItype === "1" && (
                      <p className="fst-italic help">{t("drawAOIHelp")}</p>
                    )}
                  </div>
                  <div className="panelContent dataReqPanelScroll">
                    {AOItype === "2" && (
                      <div className="mb-4 form-group">
                        <div className="mb-3 form-group">
                          <span className="text-danger">*</span>{" "}
                          <label className="filetypeclass form-label mb-2">
                            {" "}
                            {t("FileType")}
                          </label>
                          <Select
                            id="fileTypeDDl"
                            value={options.find(
                              (option) => option.value === selectedFileType
                            )}
                            onChange={handleSelectChange}
                            options={options}
                            className={`react-select-container`}
                            classNamePrefix="react-select"
                            components={{
                              DropdownIndicator: CustomDropdownIndicator,
                            }}
                          />
                        </div>
                        <div className="form-group mb-3">
                          <div
                            id="drag-area"
                            className="drag-area"
                            onClick={handlebrowse}
                            onDragOver={handleDragOver}
                            onDrop={handleDrop}
                          >
                            <p className="mb-0">{t("DragDrop")} </p>
                            <p className="mb-0">{t("Or")}</p>
                            <button className="link-secondary-forgot text-decoration-none nobuttonStyle link-color">
                              {t("BrowseFiles")}
                            </button>
                            <input
                              type="file"
                              id="Externalfile"
                              onChange={fileUploadonchange}
                              ref={externalFileRef}
                              style={{ display: "none" }}
                            />
                          </div>
                          {errors.validFile && (
                            <div className="text-danger">{errors.validFile}</div>
                          )}
                          <div id="fileList" className="mt-3"></div>
                        </div>
                      </div>
                    )}
                    <div
                      className={`other-inputs   ${aoiAddedToMap ? "enabled" : "disabled"
                        }`}
                      style={{
                        opacity: aoiAddedToMap ? 1 : 0.5,
                        cursor: aoiAddedToMap ? "pointer" : "default",
                        userSelect: aoiAddedToMap ? "auto" : "none",
                        pointerEvents: aoiAddedToMap ? "auto" : "none",
                      }}
                    >
                      <div className="form-group mb-3">
                        <span className="text-danger">*</span>{" "}
                        <label htmlFor="mapService" className="mb-2">
                          {" "}
                          {t("selectMapservice")}
                        </label>
                        <Select
                          id="mapService"
                          name="mapService"
                          value={mapserviceoptions.find(
                            (option) => option.value === selectedMapservice
                          )} // Set the selected option (an object, not just the id)
                          onChange={handleMapServiceChange} // Handle the change with the selected option
                          options={mapserviceoptions} // Pass the options for react-select
                          className={`react-select-container`}
                          classNamePrefix="react-select"
                          components={{
                            DropdownIndicator: CustomDropdownIndicator,
                          }}
                        />
                      </div>
                      <div className="form-group mb-3">
                        <span className="text-danger">*</span>{" "}
                        <label htmlFor="mapLayer" className="mb-2">
                          {" "}
                          {t("selectLayer")}
                        </label>
                        <ul className="mapLayers dataRevChkWrp">
                          {maplayers &&
                            maplayers.length > 0 &&
                            maplayers.map((layer) => (
                              <li key={layer.id} className="dataRevChkBlk">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={selectedLayers.includes(layer.id)}
                                  onChange={() => handleLayerChange(layer.id)}
                                />
                                <label>{layer.layerName}</label>
                              </li>
                            ))}
                        </ul>
                      </div>
                      <div className="form-group mb-3">
                        <span className="text-danger">*</span>{" "}
                        <label htmlFor="email" className="form-label mb-2">
                          {t("email")}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                        {errors.email && (
                          <div className="text-danger">{errors.email}</div>
                        )}
                      </div>
                      <div className="form-group mb-3">
                        <label className="label mb-2">{t("purpose")}</label>
                        <textarea
                          rows={4}
                          cols={100}
                          className="form-control customtextarea"
                          value={purpose}
                          onChange={(e) => setPurpose(e.target.value)}
                        />
                      </div>

                      <div className="form-group mb-3">
                        <label className="label mb-2">{t("Upload document")}</label>
                        <div
                          id="drag-area"
                          className="drag-area"
                          onClick={handlebrowse}
                          onDragOver={handleDragOver}
                          onDrop={handleDrop}
                        >
                          <p className="mb-0">{t("DragDrop")} </p>
                          <p className="mb-0">{t("Or")}</p>
                          <button className="link-secondary-forgot text-decoration-none nobuttonStyle link-color">
                            {t("BrowseFiles")}
                          </button>
                          <input
                            type="file"
                            id="Externalfile"
                            onChange={fileUploadonchange}
                            ref={externalFileRef}
                            style={{ display: "none" }}
                          />
                        </div>
                        {errors.validFile && (
                          <div className="text-danger">{errors.validFile}</div>
                        )}
                        <div id="fileList" className="mt-3"></div>
                      </div>
                      <small className="text-muted">{t("invalidFileMessageForPDF")}</small>
                      {/* <span className="text-danger">*</span>{" "} */}
                      <label htmlFor="startDate" className={`mb-2 ${tabularData ? "" : "d-none"}`}>
                        {" "}
                        {t("Time Range")}
                      </label>
                      <div className={`d-flex justify-content-between row ${tabularData ? "" : "d-none"}`}>
                        <div className="form-group mb-3 col-6">
                          <input
                            type="date"
                            name="startDate"
                            value={filter.startDate}
                            onChange={handleDateRangeChange}
                            max={new Date().toLocaleDateString('en-CA')}
                            className="form-control"
                          />
                          {errors.startDate && (
                            <div className="text-danger">{errors.startDate}</div>
                          )}
                        </div>
                        <div className="form-group mb-3 col-6">
                          <input
                            type="date"
                            name="endDate"
                            value={filter.endDate}
                            onChange={handleDateRangeChange}
                            max={new Date().toLocaleDateString('en-CA')}
                            className="form-control"
                          />
                          {errors.endDate && (
                            <div className="text-danger">{errors.endDate}</div>
                          )}
                        </div>
                        {selectedMapservice &&
                          !filter.startDate &&
                          filter.endDate && (
                            <div className="text-danger">
                              {t("requiredField")}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="d-flex gap-2 panelfooter abs">
                  <button
                    className="btn btn-outline reset-btn"
                    onClick={handleClear}
                  >
                    {t("cancel")}
                  </button>
                  {aoiAddedToMap &&
                    selectedMapservice &&
                    selectedLayers.length > 0 &&
                    email !== "" //&&
                    // filter.startDate !== "" &&
                    // filter.endDate !== "" 
                    ? (
                      <button
                        className="btn btn-primary custom-btn"
                        onClick={submitDataRequest}
                      >
                        {t("submit")}
                      </button>
                    ) : (
                      <button className="btn btn-primary custom-btn disabled">
                        {t("submit")}
                      </button>
                    )}

                  {/* <button className="btn btn-primary" onClick={toggleDataSection}>
                {t("Data")}
              </button> */}
                </div>
              </>
            )}






          </div>
          {loading && <DivLoader />}
        </Fragment>
      ) : (
        <PageLoader />
      )}
    </DataRequestContext.Provider>
  );
});

export default DataRequest;
